import { AbstractControlOptions, UntypedFormBuilder } from '@angular/forms';
import { Injectable } from '@angular/core';
import { FormGroupExt } from './form-group.ext';
import { ReadableErrors } from './interfaces/readable-errors.interface';

@Injectable({
    providedIn: 'root',
})
export class FormBuilderExt extends UntypedFormBuilder {
    public groupExt(
        controlsConfig: { [p: string]: any },
        options?: AbstractControlOptions | { [p: string]: any } | null,
        readableErrors?: ReadableErrors,
    ): FormGroupExt {
        const group = super.group(controlsConfig, options);
        const groupExt: FormGroupExt = new FormGroupExt(group);

        if (readableErrors === null || readableErrors === undefined) {
            throw new Error('Invalid readable errors in form ext');
        }

        groupExt.setReadableErrors(readableErrors);

        return groupExt;
    }
}
